<template>
  <router-view/>

  <Transition name="toast-code-admin">
    <div v-if="auth.codeAdminPanelAffiche" class="toast-code-admin">
      <div class="toast-code-admin-entete">
        <span class="toast-code-admin-titre">🔐 Connexion admin-panel</span>
        <button type="button" class="toast-code-admin-fermer" @click="auth.fermerCodeAdminPanel">✕</button>
      </div>
      <div class="toast-code-admin-code">{{ auth.codeAdminPanelAffiche }}</div>
      <button type="button" class="btn-outline" style="width: 100%;" @click="auth.copierCodeAdminPanel">{{ auth.codeAdminPanelCopie ? 'Copié ✓' : 'Copier le code' }}</button>
    </div>
  </Transition>
</template>

<script setup>
import { onMounted } from 'vue'
import { usePreferencesStore } from '@/stores/preferences'
import { useAuthStore } from '@/stores/auth'

const preferences = usePreferencesStore()
const auth = useAuthStore()
onMounted(() => preferences.initTheme())
</script>
